import styled from '@emotion/styled';
import { ButtonGroup } from '@modernhealth/vital-components';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useFlags } from 'launchdarkly-react-client-sdk';

import logoImg from 'src/public/img/mh-logo-text.svg';
import { InternalLinkButton } from 'src/shared/components/InternalLinkButton';
import { color, font } from 'src/shared/styles/variables';
import landingPageImage from 'src/shared/svg/welcome-magic-link/landing-page.svg';

const Container = styled.div({
    display: 'flex',
    width: '100%',
    justifyContent: 'center',
    alignItems: 'center',
    flexGrow: 1,
});
const ContentContainer = styled.div({
    textAlign: 'center',
    minWidth: '500px',
    flexDirection: 'column',
});
const Title = styled.h1(
    {
        paddingTop: '16px',
        color: color.ebonyClay,
        lineHeight: '44px',
        marginBottom: '8px',
    },
    font.heavy(font.size.headerPlus),
);
const Subtitle = styled.h3(
    {
        color: color.blueBayoux,
        lineHeight: '24px',
        paddingBottom: '40px',
        marginBottom: 0,
    },
    font.book(font.size.medium),
);
const BrandImage = styled.img({
    marginLeft: 32,
    marginTop: 20,
    width: '15em',
    cursor: 'pointer',
    marginRight: 12,
});

export const LandingPage: React.FC = () => {
    const { t } = useTranslation();
    const { climbSsoOnly } = useFlags();

    return (
        <>
            <BrandImage
                src={logoImg}
                onClick={() => {
                    window.location.href = 'https://www.modernhealth.com';
                }}
            />
            <Container>
                <ContentContainer>
                    <img src={landingPageImage} alt="girls with smartphone and laptop" />
                    <Title>{t('auth:landing_page.title')}</Title>
                    <Subtitle>{t('auth:landing_page.subtitle')}</Subtitle>
                    <ButtonGroup>
                        <InternalLinkButton to="/login" variant="secondary" size="large">
                            {t('auth:landing_page.log_in')}
                        </InternalLinkButton>
                        <InternalLinkButton
                            to={climbSsoOnly ? '/register' : '/registration-basics'}
                            variant="primary"
                            size="large"
                        >
                            {t('auth:landing_page.sign_up')}
                        </InternalLinkButton>
                    </ButtonGroup>
                </ContentContainer>
            </Container>
        </>
    );
};
